module.exports = __webpack_public_path__ + "img/智能识别首图bg.629c4008.png";